const HTTP_FORBIDDEN = 403;
const REFUSAL_HEADLINE = "You can't join this call";
const REFUSAL_FALLBACK_MESSAGE = "You don't have access to this call.";

export function isJoinRefusal(error) {
  return error?.status === HTTP_FORBIDDEN;
}

export function refusalBanner(reason) {
  return {
    headline: REFUSAL_HEADLINE,
    message: reason || REFUSAL_FALLBACK_MESSAGE,
  };
}
